import axios, { AxiosError } from 'axios'
import toast from 'react-hot-toast'

import { NotificationType } from '../interfaces/notificationTypeEnum'
import { api } from '../libs/axios'
import store from '../reducers'
import { setCityOptions, setCurrentTerms, setIsLoading, setStateOptions } from '../reducers/appReducer'
import { Profile, setProfile } from '../reducers/authReducer'

const dispatch = store.dispatch

type IBGEApiStateResponse = {
  sigla: string
  nome: string
}[]

export async function setStateOptionsAction() {
  const { data } = await axios.get<IBGEApiStateResponse>('https://servicodados.ibge.gov.br/api/v1/localidades/estados')

  const statesList = data.map(state => ({
    value: state.sigla,
    label: state.nome,
  }))

  dispatch(setStateOptions(statesList))
}

export async function setCityByStateOptionsAction(state: string) {
  let citiesByState: { value: string, label: string }[] = []
  if (state === 'DF') {
    const citiesDF = [
      'Plano Piloto',
      'Gama',
      'Taguatinga',
      'Brazlândia',
      'Sobradinho',
      'Planaltina',
      'Paranoá',
      'Núcleo Bandeirante',
      'Ceilândia',
      'Guará',
      'Cruzeiro',
      'Samambaia',
      'Santa Maria',
      'São Sebastião',
      'Recanto das Emas',
      'Lago Sul',
      'Riacho Fundo',
      'Lago Norte',
      'Candangolândia',
      'Águas Claras',
      'Riacho Fundo II',
      'Sudoeste/Octogonal',
      'Varjão',
      'Park Way',
      'SCIA/Estrutural',
      'Sobradinho II',
      'Jardim Botânico',
      'Itapoã',
      'SIA',
      'Vicente Pires',
      'Fercal',
      'Sol Nascente/Pôr do Sol',
      'Arniqueira',
      'Arapoanga',
      'Água Quente',
    ]

    citiesByState = citiesDF.map(city => ({
      value: city,
      label: city,
    }))
  } else {
    const { data } = await axios.get<IBGEApiStateResponse>(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/municipios`)

    citiesByState = data.map(state => ({
      value: state.nome,
      label: state.nome,
    }))
  }

  dispatch(setCityOptions(citiesByState))
}

export async function getLoggedUser(token: string) {
  const { data } = await api.get('/me', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  dispatch(setProfile(data.user))
}

export interface Notification {
  id: string
  description?: string
  notification_recipient?: {
    id: string
    viewed_at: Date | null
  }[]
  resource_id: string
  resource: {
    store: {
      id: string
      name: string
      group: {
        logo_url: string
      }
    }
  }
  type: NotificationType
  created_at: Date | string
}

interface GetNotificationsResponse {
  notifications: Notification[]
}

export async function getNotifications() {
  const { data } = await api.get<GetNotificationsResponse>('/notifications')

  if (data) {
    return data.notifications
  }
  return []
}

export interface MarkNotificationAsSeenResponse {
  id: string
  notification: {
    id: string
    description?: string
    type: NotificationType
    created_at: Date
  }
  viewed_at: Date
}

export async function markNotificationAsSeen(notification_id: string) {
  try {
    const { data } = await api.patch<MarkNotificationAsSeenResponse>(`/notifications/${notification_id}`)

    return {
      notification: data,
      success: true,
      message: 'Operação realizada com sucesso',
    }
  } catch (error) {
    if (error instanceof AxiosError) {
      return {
        data: undefined,
        success: false,
        message: error.response?.data.message ?? 'Não foi possível marcar a notificação como vista',
      }
    }
    console.log(error)
  }
}

export async function getCurrentTerms() {
  const dispatch = store.dispatch
  dispatch(setIsLoading(true))
  try {
    const { data } = await api.get('/terms')

    dispatch(setCurrentTerms({
      id: data.currentTerms.id,
      version: data.currentTerms.version,
      content: data.currentTerms.content,
    }))
  } catch (error) {
    if (error && (error as AxiosError).code === 'DUPLICATE_REQUEST') {
      console.log(error)
    } else {
      console.log(error)
      toast.error('Não foi possível carregar os termos de uso')
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}

export async function acceptTerms(termsId: string, token: string) {
  const dispatch = store.dispatch
  const { profile } = store.getState().auth
  try {
    const { data } = await api.patch(`/terms/${termsId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    if (data.acceptedTerms && profile) {
      const newProfile: Profile = {
        ...profile,
        terms_acceptance: [data.acceptedTerms],
      }
      dispatch(setProfile(newProfile))
      return {
        success: true,
        message: 'Termos de serviço aceitos com sucesso!',
      }
    }
  } catch (error) {
    if (error && (error as AxiosError).code === 'DUPLICATE_REQUEST') {
      console.log(error)
    }
    if (error instanceof AxiosError) {
      return {
        success: false,
        message: error.response?.data.message || 'Não foi possível concluir a ação.',
      }
    }
  }
}
